const config = {
  localhost: {
    production: false,
    ENV: "dev",
    COGNITO_AUTH: {
      region: "us-west-2",
      userPoolId: "us-west-2_HG4jXkc8G",
      userPoolWebClientId: "4iq22397h9cfl1l3iiejbcfusn",
      authenticationFlowType: "USER_SRP_AUTH",
      cookieStorage: {
        domain: document.domain,
        path: "/",
        expires: null,
        secure: false,
      },
      oauth: {
        domain: "auth.dev.riskandsafety.com",
        scope: ["openid", "aws.cognito.signin.user.admin"],
        redirectSignIn: `http://localhost:4200`,
        redirectSignOut: `http://localhost:4200`,
        responseType: "code",
      },
    },
    RSS_AUTH_CLIENT_URL: "http://localhost:5000/auth",
  },
  dev: {
    production: false,
    ENV: "dev",
    COGNITO_AUTH: {
      region: "us-west-2",
      userPoolId: "us-west-2_HG4jXkc8G",
      userPoolWebClientId: "8il5qps36agta2degkr6s1scg",
      authenticationFlowType: "USER_SRP_AUTH",
      cookieStorage: {
        domain: document.domain,
        path: "/",
        expires: null,
        secure: true,
      },
      oauth: {
        domain: "auth.dev.riskandsafety.com",
        scope: ["openid", "aws.cognito.signin.user.admin"],
        redirectSignIn: `${document.location.protocol}//${document.location.host}`,
        redirectSignOut: `${document.location.protocol}//${document.location.host}/public/signout`,
        responseType: "code",
      },
    },
    RSS_AUTH_CLIENT_URL: "/auth",
  },
  qa: {
    production: false,
    ENV: "qa",
    COGNITO_AUTH: {
      region: "us-west-2",
      userPoolId: "us-west-2_bIillxdK1",
      userPoolWebClientId: "usu33q80fg4o0mnsrgkli5nie",
      authenticationFlowType: "USER_SRP_AUTH",
      cookieStorage: {
        domain: document.domain,
        path: "/",
        expires: null,
        secure: true,
      },
      oauth: {
        domain: "auth.qa.riskandsafety.com",
        scope: ["openid", "aws.cognito.signin.user.admin"],
        redirectSignIn: `${document.location.protocol}//${document.location.host}`,
        redirectSignOut: `${document.location.protocol}//${document.location.host}/public/signout`,
        responseType: "code",
      },
    },
    RSS_AUTH_CLIENT_URL: "/auth",
  },
  prod: {
    production: true,
    ENV: "prod",
    COGNITO_AUTH: {
      region: "us-west-2",
      userPoolId: "us-west-2_s6n7nvnyK",
      userPoolWebClientId: "69v6qi0s1oqqknq8is35r6bl6v",
      authenticationFlowType: "USER_SRP_AUTH",
      cookieStorage: {
        domain: document.domain,
        path: "/",
        expires: null,
        secure: true,
      },
      oauth: {
        domain: "auth.app.riskandsafety.com",
        scope: ["openid", "aws.cognito.signin.user.admin"],
        redirectSignIn: `${document.location.protocol}//${document.location.host}`,
        redirectSignOut: `${document.location.protocol}//${document.location.host}/public/signout`,
        responseType: "code",
      },
    },
    RSS_AUTH_CLIENT_URL: "/auth",
  },
};

const [host1, host2] = window.location.hostname.split(".");

export const { production, ENV, COGNITO_AUTH, RSS_AUTH_CLIENT_URL } =
  config[host1] || config[host2] || config.prod;



// WEBPACK FOOTER //
// /home/runner/work/slipresistant/slipresistant/client/src/app/config/auth-config.ts